/**
 * User Verification utilities.
 *
 * Admin marks users as verified. Verification badge appears on profile.
 *
 * Storage: user.metadata.verified = true | false
 * Storage: user.metadata.verifiedAt = ISO string
 * Storage: user.metadata.verifiedType = 'identity' | 'business' | 'phone'
 *
 * Verification types:
 *   identity — ID document verified
 *   business — business registration verified
 *   phone    — phone number verified
 */

export const VERIFICATION_TYPES = ['identity', 'business', 'phone'];

export const VERIFICATION_BADGES = {
  identity: { label: 'ID Verified', emoji: '🪪', color: '#1a56db' },
  business: { label: 'Business Verified', emoji: '🏢', color: '#059669' },
  phone: { label: 'Phone Verified', emoji: '📱', color: '#7c3aed' },
};

/**
 * Check if a user is verified.
 * @param {Object|null} user — Sharetribe user object
 * @returns {boolean}
 */
export const isVerified = (user) =>
  user?.attributes?.metadata?.verified === true;

/**
 * Get verification details.
 * @param {Object|null} user
 * @returns {{ type: string, verifiedAt: string | null } | null}
 */
export const getVerificationDetails = (user) => {
  if (!isVerified(user)) return null;
  const { verifiedType, verifiedAt } = user.attributes.metadata;
  return { type: verifiedType || 'identity', verifiedAt: verifiedAt || null };
};

/**
 * Get badge config for a verification type.
 * @param {string} type
 * @returns {Object}
 */
export const getBadgeConfig = (type) =>
  VERIFICATION_BADGES[type] || VERIFICATION_BADGES.identity;
